import { configureStore } from '@reduxjs/toolkit';
import authUserReducer from './stores/AuthUser';
import appReducer from './stores/App';

export default configureStore({
  reducer: {
    authUser: authUserReducer,
    app: appReducer,
  },
});
